import React from 'react';
import './css/LeaderboardSkeletonLoader.css';

function LeaderboardSkeletonLoader() {
  return (
    <div className="skeleton-loader">
      <div className="skeleton-header"></div>
      <div className="skeleton-table">
        
      </div>
      <div className="skeleton-button"></div>
    </div>
  );
}

export default LeaderboardSkeletonLoader;